import {
  ADD_CALENDAR_DATA,
  ADD_INBOX_DATA,
  ADD_CASE_DETAILS,
  ADD_PROFILE_DATA,
  GET_USERS_DATA,
  UPDATE_FETCH_USERS_DATA_INPROGRESS,
  GET_USER_PROFILE_DATA,
  DELETE_USER_DATA,
  EDIT_PROFILE_DATA,
  USER_LOGIN_DATA,
  USER_LOGIN_ERROR,
  USER_LOGOUT,
  GET_USERS_BY_GROUP_ID,
  SET_APP_CONFIGURATIONS,
  SET_AWS_CREDENTIALS,
  ADD_AVAILABILITY_DATA,
  ADD_HOLIDAY_DATA,
  UPDATE_HOLIDAY_DATA_INPROGRESS,
  GET_CASE_HISTORY_DATA,
  GET_USERS_LIST_BY_GROUP_ID,
  ADD_DISPATCH_DATA,
  UPDATE_DISPATCH_DATA_FETCH_INPROGRESS,
  ADD_READY_FOR_PICKUP,
  UPDATE_READY_FOR_PICKUP_FETCH_INPROGRESS,
  ADD_IN_PROGRESS_DATA,
  UPDATE_FETCH_PROGRESS_DATA_INPROGRESS,
  ADD_COMPLETE_DATA,
  UPDATE_FETCH_COMPLETE_DATA_INPROGRESS,
  ADD_PATHOLOGIST_PENDING_DATA,
  UPDATE_FETCH_PATHOLOGIST_PENDING_DATA_INPROGRESS,
  ADD_PATHOLOGIST_COMPLETED_DATA,
  UPDATE_FETCH_PATHOLOGIST_COMPLETE_DATA_INPROGRESS,
  CALENDAR_ERROR,
  FILTER_PAYLOAD,
  RECEIVE_SLIDES_DATA,
  SEND_SLIDES_DATA,
  GET_USER_LIST_MINIMAL_DATA,
  ADD_USER_DROPDOWN,
  UPDATE_CASEHISTORY_FETCH_INPROGRESS,
  UPDATE_INBOX_DATA_FETCH_INPROGRESS,
  ADD_RECENTLY_RELEASED_DATA,
  UPDATE_FETCH_RECENTLY_RELEASED_INPROGRESS,
  ADD_UNASSIGNED_DATA,
  UPDATE_FETCH_UNASSIGNED_DATA_INPROGRESS,
  ADD_ASSIGNED_DATA,
  UPDATE_FETCH_ASSIGNED_DATA_INPROGRESS,
  ADD_QC_CASES_DATA,
  UPDATE_FETCH_QC_DATA_INPROGRESS,
  ADD_LM_COMPLETE_DATA,
  RECEIVE_PATHOLOGISTS_SLIDES_DATA,
  UPDATE_FETCH_LM_COMPLETE_DATA_INPROGRESS,
  ADD_ITADMIN_UNASSIGNED_DATA,
  UPDATE_ITADMIN_FETCH_UNASSIGNED_DATA_INPROGRESS,
  ADD_ITADMIN_ASSIGNED_DATA,
  UPDATE_ITADMIN_FETCH_ASSIGNED_DATA_INPROGRESS,
  ADD_ITADMIN_QC_CASES_DATA,
  UPDATE_ITADMIN_FETCH_QC_DATA_INPROGRESS,
  ADD_ITADMIN_COMPLETE_DATA,
  ADD_ITADMIN_SETTINGS_DATA,
  ADD_ITADMIN_STATE_DATA,
  UPDATE_ITADMIN_FETCH_COMPLETE_DATA_INPROGRESS,
  UPDATE_ITADMIN_FETCH_COMPLETE_STATE_INPROGRESS,
  CALENDAR_SUCCESS,
  ADD_SEARCH_DATA,
  UPDATE_SEARCH_DATA_INPROGRESS,
  FILTER_PROCEDURE_CODE,
  ADD_REPORTING_INFO,
  UPDATE_FETCH_REPORTING_DATA_INPROGRESS,
  ADD_LOADBALANCE_LOG_INFO,
  UPDATE_LOADBALANCE_LOG_INPROGRESS,
  DELETE_SETTING_ERROR,
  DELETE_SETTING_SUCCESS,
  ADD_LAB_TRANSFER_LIST,
  UPDATE_FETCH_QCLOGS_DATA_INPROGRESS,
  ADD_QC_LOG_INFO,
  ADD_REPORT_UPLOAD_LOG_INFO,
  UPDATE_FETCH_REPORT_UPLOAD_DATA_INPROGRESS,
  SET_REPORT_DIAGNOSIS_DATA,
  SET_CATEGORIZED_DATA,
  SET_REPORT_COMMENTS_DATA,
  SET_REPORT_COMMENT_OBJECTS_DATA,
  SET_TRF_INFO,
  SET_SLIDE_DIAGNOSIS_OPTIONS,
  SET_IMAGE_QUALITY_OPTIONS,
  GET_CASE_DATA,
  SELECT_IMAGE_FOR_REPORT,
  SET_SHOWING_RECT,
  ADD_SAMPLE_LOCATION_DATA,
  ADD_SUMMARY_TREE_DATA,
  ADD_BARCODE_DATA,
  SET_ALL_SLIDES,
  ADD_CLINICAL_INFO,
  GET_SLIDE_DIAGNOSIS,
  GET_REPORT_HISTORY,
  SET_REPORT_DATA,
  SET_PATIENT_HISTORY,
  UPDATE_PATIENTHISTORY_FETCH_INPROGRESS,
  SET_ERROR_MESSAGE,
  TOKEN_ACTIVATE_STATUS,
  GET_CPT_CODES,
  SAVE_REPORT_DATA,
  SET_DRAFT_REPORT,
  GET_PDF_BYTES,
  GET_PREMERIS_REGIONS,
  ADD_PATHOLOGISTS_LIST,
  ADD_PATHOLOGIST_NAMES_LIST,
  SET_REPORT_URL,
  SET_CASE_DIAGNOSIS,
  SET_SIGNED_URL_TO_SAVE_REPORT,
  SET_TRF_URL,
  SET_UPLOAD_URL,
  GET_SAVE_STATE,
  REFRESH_CASE,
  UPDATE_REFRESH_INPROGRESS,
  AUDIT_CLASSIFIER,
} from './actionConstants'

/**
 * Calendar Actions - Start
 * */
export function addCalendarData({ payload, user_id }) {
  return {
    type: ADD_CALENDAR_DATA,
    payload,
    user_id,
  }
}

export function calendarError({ message }) {
  return {
    type: CALENDAR_ERROR,
    message,
  }
}

export function addFilterPayload({ payload }) {
  return {
    type: FILTER_PAYLOAD,
    payload,
  }
}

export function calendarSuccess({ successMessage }) {
  return {
    type: CALENDAR_SUCCESS,
    successMessage,
  }
}

/**
 * Calendar Actions - End
 * */

export function addAvailabilityData({ payload }) {
  return {
    type: ADD_AVAILABILITY_DATA,
    payload,
  }
}

export function addHolidayData({ payload }) {
  return {
    type: ADD_HOLIDAY_DATA,
    payload,
  }
}

export function updateHolidayDataInProgress({ inProgress }) {
  return {
    type: UPDATE_HOLIDAY_DATA_INPROGRESS,
    inProgress,
  }
}

export function deleteHolidayData({ action }) {
  return {
    type: action,
  }
}

// Pathologist Data
export function addInboxData({ payload, mdid, action }) {
  return {
    type: action,
    payload,
    mdid,
  }
}

export function updateFetchInboxDataInProgress(inProgress) {
  return {
    type: UPDATE_INBOX_DATA_FETCH_INPROGRESS,
    inProgress,
  }
}

export function addPathologistPendingData({ payload, mdid }) {
  return {
    type: ADD_PATHOLOGIST_PENDING_DATA,
    payload,
    mdid,
  }
}

export function updateFetchPathologistPendingInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_PATHOLOGIST_PENDING_DATA_INPROGRESS,
  }
}

export function addPathologistCompletedData({ payload, mdid }) {
  return {
    type: ADD_PATHOLOGIST_COMPLETED_DATA,
    payload,
    mdid,
  }
}

export function updateFetchPathologistCompleteInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_PATHOLOGIST_COMPLETE_DATA_INPROGRESS,
    inProgress,
  }
}

export function addCaseDetails({ payload, mdid }) {
  return {
    type: ADD_CASE_DETAILS,
    payload,
    mdid,
  }
}

export function updateFetchHistoryInProgress(inProgress) {
  return {
    type: UPDATE_CASEHISTORY_FETCH_INPROGRESS,
    inProgress,
  }
}

export function getCaseHistory({ payload, mdid }) {
  return {
    type: GET_CASE_HISTORY_DATA,
    payload,
    mdid,
  }
}

export function updateFetchRecentlyReleasedData({ inProgress }) {
  return {
    type: UPDATE_FETCH_RECENTLY_RELEASED_INPROGRESS,
    inProgress,
  }
}

export function addPathologistRecentlyRelesedData({ payload, mdid }) {
  return {
    type: ADD_RECENTLY_RELEASED_DATA,
    payload,
    mdid,
  }
}

export function addProfileData({ payload, mdid }) {
  return {
    type: ADD_PROFILE_DATA,
    payload,
    mdid,
  }
}

export function addUser({ payload, action }) {
  return {
    type: action,
    payload,
  }
}

export function editUser({ payload, action }) {
  return {
    type: action,
    payload,
  }
}

export function getUsersList({ payload }) {
  return {
    type: GET_USERS_DATA,
    payload,
  }
}

export function updateUsersDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_USERS_DATA_INPROGRESS,
    inProgress,
  }
}

export function getUsersByGroupId({ payload, groupId }) {
  return {
    type: GET_USERS_BY_GROUP_ID,
    payload,
    groupId,
  }
}

export function getUsersListByGroupId({ payload, groupId }) {
  return {
    type: GET_USERS_LIST_BY_GROUP_ID,
    payload,
    groupId,
  }
}

export function deleteUser({ payload, userId }) {
  return {
    type: DELETE_USER_DATA,
    payload,
    userId,
  }
}

export function editProfileData({ payload, mdid }) {
  return {
    type: EDIT_PROFILE_DATA,
    payload,
    mdid,
  }
}

export function updatePathologistsReceiveSlidesData({ payload, action }) {
  return {
    type: action,
    payload,
  }
}

export function updateCompleteCaseData({ action }) {
  return {
    type: action,
  }
}

export function updateLaunchPremerisData({ action }) {
  return {
    type: action,
  }
}

export function updateFreezeReportStatus({ action }) {
  return {
    type: action,
  }
}

// User profile
export function getUserProfile({ payload }) {
  return {
    type: GET_USER_PROFILE_DATA,
    payload,
  }
}

// Login Info
export function userLogin({ payload }) {
  return {
    type: USER_LOGIN_DATA,
    payload,
  }
}

export function filterProcedureCode({ payload }) {
  return {
    type: FILTER_PROCEDURE_CODE,
    payload,
  }
}

export function userLoginError({ errorMessage, isAppConfigSuccessful }) {
  return {
    type: USER_LOGIN_ERROR,
    errorMessage,
    isAppConfigSuccessful,
  }
}

//Logistics page

export function addDispatch({ payload, userId }) {
  return {
    type: ADD_DISPATCH_DATA,
    payload,
    userId,
  }
}

export function updateDispachDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_DISPATCH_DATA_FETCH_INPROGRESS,
    inProgress,
  }
}

export function addReadyForPickup({ payload, userId }) {
  return {
    type: ADD_READY_FOR_PICKUP,
    payload,
    userId,
  }
}

export function updateReadyForPickupFetchInProgress(inProgress) {
  return {
    type: UPDATE_READY_FOR_PICKUP_FETCH_INPROGRESS,
    inProgress,
  }
}

export function addInProgressData({ payload, userId }) {
  return {
    type: ADD_IN_PROGRESS_DATA,
    payload,
    userId,
  }
}
export function updateProgressDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_PROGRESS_DATA_INPROGRESS,
    inProgress,
  }
}

export function addCompleteData({ payload, userId }) {
  return {
    type: ADD_COMPLETE_DATA,
    payload,
    userId,
  }
}
export function updateCompleteDataFetchInProgress({ inProgress }) {
  return {
    type: UPDATE_FETCH_COMPLETE_DATA_INPROGRESS,
    inProgress,
  }
}

export function updateReceiveSlidesData({ payload }) {
  return {
    type: RECEIVE_SLIDES_DATA,
    payload,
  }
}

export function updateSendSlidesData({ payload }) {
  return {
    type: SEND_SLIDES_DATA,
    payload,
  }
}
// Lab Manager
export function addUnassignedData({ payload, userId }) {
  return {
    type: ADD_UNASSIGNED_DATA,
    payload,
    userId,
  }
}

export function updateUnAssignedDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_UNASSIGNED_DATA_INPROGRESS,
    inProgress,
  }
}

export function addAssignedData({ payload, userId }) {
  return {
    type: ADD_ASSIGNED_DATA,
    payload,
    userId,
  }
}

export function updateAssignedDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_ASSIGNED_DATA_INPROGRESS,
    inProgress,
  }
}

export function addQCCasesData({ payload, userId }) {
  return {
    type: ADD_QC_CASES_DATA,
    payload,
    userId,
  }
}
export function updateQCDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_QC_DATA_INPROGRESS,
    inProgress,
  }
}

export function addLabManagerCompleteData({ payload, userId }) {
  return {
    type: ADD_LM_COMPLETE_DATA,
    payload,
    userId,
  }
}

export function updateLMCompleteDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_LM_COMPLETE_DATA_INPROGRESS,
    inProgress,
  }
}

export function addLabTransferList({ payload }) {
  return {
    type: ADD_LAB_TRANSFER_LIST,
    payload,
  }
}

//IT ADMIN
export function addITAdminUnassignedData({ payload, userId }) {
  return {
    type: ADD_ITADMIN_UNASSIGNED_DATA,
    payload,
    userId,
  }
}

export function updateITAdminUnAssignedDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_ITADMIN_FETCH_UNASSIGNED_DATA_INPROGRESS,
    inProgress,
  }
}

export function addITAdminAssignedData({ payload, userId }) {
  return {
    type: ADD_ITADMIN_ASSIGNED_DATA,
    payload,
    userId,
  }
}

export function updateITAdminAssignedDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_ITADMIN_FETCH_ASSIGNED_DATA_INPROGRESS,
    inProgress,
  }
}

export function addITAdminQCCasesData({ payload, userId }) {
  return {
    type: ADD_ITADMIN_QC_CASES_DATA,
    payload,
    userId,
  }
}
export function updateITAdminQCDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_ITADMIN_FETCH_QC_DATA_INPROGRESS,
    inProgress,
  }
}

export function addITAdminCompleteData({ payload, userId }) {
  return {
    type: ADD_ITADMIN_COMPLETE_DATA,
    payload,
    userId,
  }
}

export function addITAdminSettingsData(payload) {
  return {
    type: ADD_ITADMIN_SETTINGS_DATA,
    payload,
  }
}
export function updateITAdminCompleteDataFetchInProgress(inProgress) {
  return {
    type: UPDATE_ITADMIN_FETCH_COMPLETE_DATA_INPROGRESS,
    inProgress,
  }
}

export function updateITAdminStatesFetchInProgress(inProgress) {
  return {
    type: UPDATE_ITADMIN_FETCH_COMPLETE_STATE_INPROGRESS,
    inProgress,
  }
}

export function deleteSettingsData({ action }) {
  return {
    type: action,
  }
}
export function addSettingsData({ action }) {
  return {
    type: action,
  }
}
export function editSettingsData({ action }) {
  return {
    type: action,
  }
}
//ITADMIN STATE DATA
export function addITAdminStateData({ payload }) {
  return {
    type: ADD_ITADMIN_STATE_DATA,
    payload,
  }
}
//Holiday response
export function addHolidayResponse({ action }) {
  return {
    type: action,
  }
}
export function editHolidayResponse({ action }) {
  return {
    type: action,
  }
}
export function deleteHolidayResponse({ action }) {
  return {
    type: action,
  }
}

// App Configurations
export function setAppConfigurations({ payload }) {
  return {
    type: SET_APP_CONFIGURATIONS,
    payload,
  }
}
export function setCredentials({ payload }) {
  return {
    type: SET_AWS_CREDENTIALS,
    payload,
  }
}
export function getUsersMinimalData({ payload }) {
  return {
    type: GET_USER_LIST_MINIMAL_DATA,
    payload,
  }
}

export function addUserDropDown({ payload }) {
  return {
    type: ADD_USER_DROPDOWN,
    payload,
  }
}

export function userLogout() {
  return {
    type: USER_LOGOUT,
  }
}

export function addSearchData({ payload, userId, trfId }) {
  return {
    type: ADD_SEARCH_DATA,
    payload,
    userId,
    trfId,
  }
}

export function updateSearchDataFetchInProgress(inProgress, trfId) {
  return {
    type: UPDATE_SEARCH_DATA_INPROGRESS,
    inProgress,
    trfId,
  }
}

export function updateSearchData({ action }) {
  return {
    type: action,
  }
}

export function updateTransferResponse({ action }) {
  return {
    type: action,
  }
}

export function updateCorrectionResponse({ action }) {
  return {
    type: action,
  }
}

export function updateAmendResponse({ action }) {
  return {
    type: action,
  }
}

export function updateUnassignResponse({ action }) {
  return {
    type: action,
  }
}

export function getLabTransferListResponse({ action }) {
  return {
    type: action,
  }
}

export function addReportingInfo({ payload, userId }) {
  return {
    type: ADD_REPORTING_INFO,
    payload,
    userId,
  }
}

export function addLoadBalanceLogInfo({ payload, userId }) {
  return {
    type: ADD_LOADBALANCE_LOG_INFO,
    payload,
    userId,
  }
}

export function updateFetchReportingDataInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_REPORTING_DATA_INPROGRESS,
    inProgress,
  }
}
export function addQCLogInfo({ payload, userId }) {
  return {
    type: ADD_QC_LOG_INFO,
    payload,
    userId,
  }
}

export function updateFetchQCLogInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_QCLOGS_DATA_INPROGRESS,
    inProgress,
  }
}
export function addReportUploadLogInfo({ payload, userId }) {
  return {
    type: ADD_REPORT_UPLOAD_LOG_INFO,
    payload,
    userId,
  }
}

export function updateFetchReportUploadLogInProgress(inProgress) {
  return {
    type: UPDATE_FETCH_REPORT_UPLOAD_DATA_INPROGRESS,
    inProgress,
  }
}

export function updateFetchLoadBalanceLogInProgress(inProgress) {
  return {
    type: UPDATE_LOADBALANCE_LOG_INPROGRESS,
    inProgress,
  }
}

export function updateLogisticsReceiveSlides({ action }) {
  return {
    type: action,
  }
}
export function errorMessageDisplay({ payload }) {
  return {
    type: SET_ERROR_MESSAGE,
    payload,
  }
}

export function updateLogisticsSendSlides({ action }) {
  return {
    type: action,
  }
}

/**
 * Premeris Actions - Start
 * */

export function setReportDiagnosisData(payload) {
  return {
    type: SET_REPORT_DIAGNOSIS_DATA,
    payload,
  }
}

export function setCategorizedData(payload) {
  return {
    type: SET_CATEGORIZED_DATA,
    payload,
  }
}

export function addTrfInfo({ payload }) {
  return {
    type: SET_TRF_INFO,
    payload,
  }
}

export function setSlideDiagnosisOptions(payload) {
  return {
    type: SET_SLIDE_DIAGNOSIS_OPTIONS,
    payload,
  }
}

export function setImageQualityOptions(payload) {
  return {
    type: SET_IMAGE_QUALITY_OPTIONS,
    payload,
  }
}

export function getCaseData({ payload }) {
  return {
    type: GET_CASE_DATA,
    payload,
  }
}

export function selectImageForReport({ payload }) {
  return {
    type: SELECT_IMAGE_FOR_REPORT,
    payload,
  }
}

export const setShowingRect = (payload) => ({
  type: SET_SHOWING_RECT,
  payload,
})

export const addSampleLocationData = (payload) => ({
  type: ADD_SAMPLE_LOCATION_DATA,
  payload,
})

export const addSummaryTreeData = (payload) => ({
  type: ADD_SUMMARY_TREE_DATA,
  payload,
})

export const setAllSlides = ({ payload }) => ({
  type: SET_ALL_SLIDES,
  payload,
})

export const addBarcodeData = (payload, error) => ({
  type: ADD_BARCODE_DATA,
  payload,
  error,
})

export function addClinicalInfo(payload) {
  return {
    type: ADD_CLINICAL_INFO,
    payload,
  }
}

export const saveSlideDiagnosisData = ({ action }) => ({
  type: action,
})

export const saveDraftReport = ({ action }) => ({
  type: action,
})

export const setDraftReportData = ({ payload }) => ({
  type: SET_DRAFT_REPORT,
  payload,
})

export const getSlideDiagnosisData = (payload) => ({
  type: GET_SLIDE_DIAGNOSIS,
  payload,
})

export const getReportHistoryData = (payload) => ({
  type: GET_REPORT_HISTORY,
  payload,
})

export const setReportData = ({ payload }) => ({
  type: SET_REPORT_DATA,
  payload,
})

export const setPatientHistory = (payload) => ({
  type: SET_PATIENT_HISTORY,
  payload,
})

export function updateFetchPatientHistoryInProgress(inProgress) {
  return {
    type: UPDATE_PATIENTHISTORY_FETCH_INPROGRESS,
    inProgress,
  }
}

export const getsessionStatus = ({ action, payload }) => ({
  type: action,
  payload,
})

export const tokenActiveStatus = ({ payload }) => ({
  type: TOKEN_ACTIVATE_STATUS,
  payload,
})

export const getCPTCodesData = (payload) => ({
  type: GET_CPT_CODES,
  payload,
})

export const getPDFBytes = (payload) => ({
  type: GET_PDF_BYTES,
  payload,
})

export function saveReportDataResponse({ action }) {
  return {
    type: action,
  }
}

export function saveAmendResponse({ action }) {
  return {
    type: action,
  }
}

export function updateConsultResponse({ action }) {
  return {
    type: action,
  }
}

export function updateConsultCompleteResponse({ action }) {
  return {
    type: action,
  }
}

export function addPathologistsList({ payload }) {
  return {
    type: ADD_PATHOLOGIST_NAMES_LIST,
    payload,
  }
}

export function getPathologistsListResponse({ action }) {
  return {
    type: action,
  }
}

export const setSignedUrlToGetReport = (payload) => ({
  type: SET_REPORT_URL,
  payload,
})

export const setSignedUrlToGetTrf = (payload) => ({
  type: SET_TRF_URL,
  payload,
})

export const setCaseDiagnosis = (payload) => ({
  type: SET_CASE_DIAGNOSIS,
  payload,
})

export const setSignedURLToSaveReport = (payload) => ({
  type: SET_SIGNED_URL_TO_SAVE_REPORT,
  payload,
})

export const setURLForReportPDF = (payload) => ({
  type: SET_UPLOAD_URL,
  payload,
})

export const getSaveState = (payload) => ({
  type: GET_SAVE_STATE,
  payload,
})

export function refreshCase({ payload }) {
  return {
    type: REFRESH_CASE,
    payload,
  }
}
export function refreshResponse({ action }) {
  return {
    type: action,
  }
}

export function updateRefreshInProgress({ inProgress }) {
  return {
    type: UPDATE_REFRESH_INPROGRESS,
    inProgress,
  }
}
export function auditClassifier({ payload }) {
  return {
    type: AUDIT_CLASSIFIER,
    payload,
  }
}

/**
 * Premeris Actions - End
 * */
